import '@babel/polyfill';
import BootstrapVue from 'bootstrap-vue';
// import 'bootstrap-vue/dist/bootstrap-vue.css';
import './theme/boostrap/custom.scss';
import './theme/ivew-theme/output/iview.css';
import iView from 'iview';
import { HimuraInject } from 'himura';
import { CommonConfig } from './configs/config.common';
import Vue from 'vue';
import VueRouter from 'vue-router';
import App from './App.vue';
// @ts-ignore
import VueParticles from 'vue-particles';
// @ts-ignore
import Vue2Filters from 'vue2-filters';
// @ts-ignore
import locale from 'iview/dist/locale/en-US';
// @ts-ignore
import VueHtml2Canvas from 'vue-html2canvas';
// @ts-ignore
import VueBrowserstore from 'vue-browserstore';
import GlobalContextPlugin from './vue-plugin/global.context';
import VueMeta from 'vue-meta';
const VueGoogleMaps = require('vue2-google-maps');

HimuraInject.Init(false);
const config = new CommonConfig();
Vue.use(VueHtml2Canvas);
Vue.use(VueParticles);
Vue.use(VueRouter);
Vue.use(VueBrowserstore);
Vue.use(BootstrapVue);
Vue.use(GlobalContextPlugin);
Vue.use(iView, { locale });
Vue.use(Vue2Filters);
Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
});
Vue.use(VueGoogleMaps, {
  load: {
    key: config.googleAppKey,
    libraries: 'places',
  },
});
Vue.directive(
  'click-outside', {
  bind: function (el: any, binding, vNode: any) {
    // Provided expression must evaluate to a function.
    if (typeof binding.value !== 'function') {
      const compName = vNode.context.name;
      let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`;
      if (compName) { warn += `Found in component '${compName}'`; }

      console.warn(warn);
    }
    // Define Handler and cache it on the element
    const bubble = binding.modifiers.bubble;
    const handler = (e: any) => {
      if (bubble || (!el.contains(e.target) && el !== e.target)) {
        binding.value(e);
      }
    };
    el.__vueClickOutside__ = handler;

    // add Event Listeners
    document.addEventListener('click', handler);
  },
  unbind: function (el: any, binding) {
    // Remove Event Listeners
    document.removeEventListener('click', el.__vueClickOutside__);
    el.__vueClickOutside__ = null;

  }
}
);
Vue.config.productionTip = false;

new Vue({
  render: (h) => h(App)
}).$mount('#app');
